(function($, window) {
  var today = new Date($('#h_checkin').val());
  var tomorrow = new Date( today.getTime() + (1000*60*60*24) );

  var defaults = {
    startDay:       0, // 0 is Sunday
    checkRange:     [today, tomorrow],
    disableDate:    [],
    disableButton:  {
      clickable: {
        afterCurrent: false, // The days over maxDate
        beforeCurrent: false, // The days under minDate
        current: false // The days between minDate and maxDate
      }
    },
    minDate:        null,
    maxDate:        null,
    
    init:           true,
    children:       '.calendar',

    navigation:     {
      prevEl:       '.calendar-button-prev',
      nextEl:       '.calendar-button-next',
      prevText:     'Prev',
      nextText:     'Next'
    },

    className: {
      today:        'is-today',
      future:       'is-future',
      past:         'is-past',
      weekend:      'is-weekend',
      checkin:      'is-checkin',
      checkout:     'is-checkout',
      selected:     'is-select',
      ranged:       'is-range',
      disabled:     'is-disable'
    },

    /**
     * You cannot change existing class name
     * but you can add more class OR add/remove elements what you need
     */
    template: `<div class="tl-datepicker">
      <div class="tl-datepicker__title"></div>
      <div class="tl-datepicker__week"></div>
      <div class="tl-datepicker__days"></div>
    </div>`,

    day: {
      template: '<div class="{{className}}">{{button}}</div>'
    },

    onInit:         function() {},
    onChange:       function() {},
    onBeforeChange: function() {},
    onDateSelect:   function() {}
  }

  function dateFormat(d, f = 'YYYY-MM-DD') {
    return moment(d).format(f);
  }

  function Calendar(element, options) {
    var conf = $.extend(true, {}, defaults, options);

    var
    $parent = $(element);

    var methods = {
      settings: {
        $el: {
          parent: $parent
        },
        checkRange: conf.checkRange,
        disableDate: conf.disableDate,
        disableButton: conf.disableButton,
        month: new Date( today.getFullYear(), today.getMonth(), 1 ),
        numofmonth: null,
        minDate: conf.minDate,
        maxDate: conf.maxDate,
        startDay: conf.startDay,
        template: conf.template,
        navigation: conf.navigation,
        day: {
          template: conf.day.template
        }
      },

      init: function() {
        // get range data
        var range = this.settings.checkRange;

        // get template data and render
        var $children = $(element).find(conf.children);
        this.settings.numofmonth = $children.length;
        
        $children.html(this.settings.template);
        $children.each((i, el) => this.renderDatepicker(el, i));

        // Render date range selected UI
        var checkin = new Date(range[0]);
        var checkout = new Date(range[1]);
        this.renderRange( checkin, checkout );

        // then set calendar to date range
        this.goto( checkin.getFullYear(), checkin.getMonth() );

        // bind buttons event
        this.bindEvent();

        this.navigation();

        // Run onInit callback
        this.onInit(this.settings);
        createEvent('init', this.settings);
      },

      bindEvent: function() {
        $parent.on('click', '[data-date]', (event) => {
          var
          DATA = event.currentTarget.dataset,
          selectedDate = DATA.date,
          newRange = this.settings.checkRange;

          if (newRange.length !== 1) {
            newRange.length = 0
            newRange.push(selectedDate);
          } else {
            if (is.inArray(selectedDate, newRange)) {
              newRange.length = 0;
            } else {
              newRange.push(selectedDate);
              newRange.sort(function(a, b) {
                return new Date(a) - new Date(b);
              });
            }
          }

          this.renderRange( newRange[0], newRange[1] );

          var date = new Date(selectedDate);
          this.onDateSelect(selectedDate, {
            Date: date,
            year: date.getFullYear(),
            month: date.getMonth(),
            date: date.getDate(),
            day: date.getDay(),
          }, newRange);

          createEvent('dateSelect', this.settings);
        });
      },

      reInit: function() {
        var range = this.settings.checkRange;
        var $children = $(element).find(conf.children);
        this.settings.numofmonth = $children.length;

        var checkin = new Date(range[0]);
        var checkout = new Date(range[1]);
        $children.html(this.settings.template);
        $children.each((i, el) => this.renderDatepicker(el, i));
        this.renderRange( checkin, checkout );
        this.goto( checkin.getFullYear(), checkin.getMonth() );
        createEvent('reInit', this.settings);
      },

      /**
       * @param {Number} y Year in number
       * @param {Number} m Month in number with zero base
       */
      goto: function(y, m) {
        this.onBeforeChange(this.settings);

        var $children = $(element).find(conf.children);
        $children.each((i, el) => {
          var $el = $(el);
          var date = moment(new Date(y,m)).add(i, 'month');

          $el.find('.tl-datepicker__title').text( date.format('MMMM YYYY') );
          $el.find('.tl-datepicker__days').empty();

          for (var day = 1; day <= date.daysInMonth(); day++) {
            $el.find('.tl-datepicker__days').append(this.renderDay(date.year(), date.month(), day));
          }
        });

        this.settings.month = new Date(y, m);
        this.renderRange(this.settings.checkRange[0], this.settings.checkRange[1]);
        this.onChange(this.settings);

        createEvent('calendarChange', this.settings);
      },

      next: function() {
        var curr = this.settings.month;
        var next = moment(curr).add(1, 'month');
        var $children = $(element).find(conf.children);
        var offset = $children.length-1;
        var maxDate = !!this.settings.maxDate && next.isAfter(moment(this.settings.maxDate).subtract(offset, 'month'), 'month');

        if (maxDate) return;

        this.goto( next.year(), next.month() );
      },

      prev: function() {
        var curr = this.settings.month;
        var prev = moment(curr).subtract(1, 'month');
        var minDate = !!this.settings.minDate && prev.isBefore(dateFormat(this.settings.minDate), 'month');

        if (minDate) return;

        this.goto( prev.year(), prev.month() );
      },

      /**
       * @param {Number} y Year in number
       * @param {Number} m Month in number with zero base
       * @param {Number} d Date in number
       */
      renderDay: function(y, m, d) {
        var
        settings    = this.settings,
        date        = new Date(y, m, d),
        dateF       = dateFormat(date),
        className   = ['day'],
        firstDay    = new Date(y, m).getDay() - conf.startDay,
        minimum     = !!settings.minDate && moment(dateF).isBefore(dateFormat(settings.minDate)),
        maximum     = !!settings.maxDate && moment(dateF).isAfter(dateFormat(settings.maxDate)),
        disable     = is.inArray(dateF, settings.disableDate);

        if (d === 1) className.push(`prepend-${firstDay}`);
        if (is.today(date)) className.push( conf.className.today );
        if (is.past(date) && is.not.today(date)) className.push( conf.className.past );
        if (is.future(date)) className.push( conf.className.future );
        if (is.weekend(date)) className.push( conf.className.weekend );
        if (minimum||maximum||disable) className.push( conf.className.disabled );

        function clickableButton() {
          if (!minimum && !maximum && !disable) return true;

          var clickable = settings.disableButton.clickable;
          if (minimum) {
            return clickable.beforeCurrent;
          } else if (maximum) {
            return clickable.afterCurrent;
          } else {
            return clickable.current;
          }
        }

        var buttonMarkup = `
        <button type="button"
          data-year="${y}"
          data-month="${m}"
          data-day="${d}"
          data-date="${dateF}"
          data-time="${dateFormat(date, 'x')}"
          ${!clickableButton()?'disabled':''}>
          <span class="date">${d}</span>
        </button>
        `;
        var dayMarkup = settings.day.template;
        var context = [
          ['{{button}}', buttonMarkup],
          ['{{className}}', className.join(' ')]
        ];

        var html = replaceAll(dayMarkup, context);
        return html;
      },

      renderWeek: function() {
        var html = '';
        for (var d = this.settings.startDay; d <= this.settings.startDay + 6; d++) {
          var className = ['day'];
          if (d === 0||d === 6) className.push( conf.className.weekend );
          html += `<div class="${className.join(' ')}">${moment().day(d % 7).format('dd')}</div>`;
        }
        return html;
      },
      
      /**
       * @param {String} el HTML selector
       * @param {Number} i Index of the emement
       */
      renderDatepicker: function(el, i) {
        var $el = $(el);
        var date = moment().add(i, 'month');
  
        $el.find('.tl-datepicker__title').text( dateFormat(date, 'MMMM YYYY') );
        $el.find('.tl-datepicker__week').append(this.renderWeek());
        $el.find('.tl-datepicker__days').empty();
  
        for (var day = 1; day <= date.daysInMonth(); day++) {
          $el.find('.tl-datepicker__days').append(this.renderDay(date.year(), date.month(), day));
        }
      },

      /**
       * @param {Date|String} checkin
       * @param {Date|String} checkout
       */
      renderRange: function(checkin, checkout) {
        var cid = !!Date.parse(checkin) ? dateFormat(checkin) : null;
        var cod = !!Date.parse(checkout) ? dateFormat(checkout) : null;
        var $btn = $parent.find('[data-date]');

        // All buttons are not checkin or checkout
        $btn.not(`[data-date="${cid}"], [data-date="${cod}"]`).parents('.day')
          .removeClass(`${conf.className.checkin} ${conf.className.checkout} ${conf.className.selected} ${conf.className.ranged}`);

        if (!cid && !cod) {
          // If checkin and checkout are not set
          $btn.removeClass( conf.className.ranged )
        } else if (!cod) {
          // If only checkin is set
          $parent.find(`[data-date="${cid}"]`).parents('.day')
            .removeClass( `${conf.className.checkout} ${conf.className.ranged}` )
            .addClass( `${conf.className.checkin} ${conf.className.selected}` )
        } else {
          // If both checkin and checkout are set
          $parent.find(`[data-date="${cid}"]`).parents('.day')
            .removeClass( `${conf.className.checkout} ${conf.className.ranged}` )
            .addClass( `${conf.className.checkin} ${conf.className.selected}` )

          $parent.find(`[data-date="${cod}"]`).parents('.day')
            .removeClass( `${conf.className.checkin} ${conf.className.ranged}` )
            .addClass( `${conf.className.checkout} ${conf.className.selected}` )

          // Find the days is between checkin and checkout and set them are ranged
          $btn.each((i, el) => {
            if (moment(el.dataset.date).isBetween(cid, cod)) {
              $parent.find(`[data-date="${el.dataset.date}"]`).parents('.day')
                .addClass( conf.className.ranged )
            }
          });
        }
      },

      navigation: function() {
        let settings = this.settings
        let prevHTML = settings.navigation.prevText
        let nextHTML = settings.navigation.nextText
        let prevBTN = $parent.find(settings.navigation.prevEl).html(prevHTML)
        let nextBTN = $parent.find(settings.navigation.nextEl).html(nextHTML)
        let minDate = settings.minDate
        let maxDate = settings.maxDate

        prevBTN.on('click', event => this.prev())
        nextBTN.on('click', event => this.next())

        $parent.on('init calendarChange', event => {
          let scope = this.getMonthsScope()

          if (!!minDate && Date.parse(minDate)) {
            prevBTN.prop('disabled', moment(scope[0]).isBefore(minDate))
          }
          
          if (!!maxDate && Date.parse(maxDate)) {
            nextBTN.prop('disabled', moment(scope[1]).isAfter(maxDate))
          }
        })
      },

      getMonthsScope: function() {
        var current = new Date(this.settings.month);
        return [
          new Date( current.setMonth( current.getMonth() ) ),
          new Date( current.getFullYear(), current.getMonth() + this.settings.numofmonth, 0 )
        ];
      },

      getRange: function() {
        var range = [];
        var r = this.settings.checkRange;
        r.forEach(el => range.push(dateFormat(el)));
        return range;
      },

      setRange: function(checkin, checkout) {
        this.update('checkRange', [checkin, checkout])
        this.renderRange(checkin, checkout);
        var scope = this.getMonthsScope()
        if (!moment( checkin ).isBetween( scope[0], scope[1] )) {
          this.reInit();
        }
      },

      update: function(option, value) {
        this.settings[option] = value;
        this.goto(this.settings.month.getFullYear(), this.settings.month.getMonth());
      },

      onInit: conf.onInit,
      onChange: conf.onChange,
      onBeforeChange: conf.onBeforeChange,
      onDateSelect: conf.onDateSelect
    }

    function createEvent(name, data) {
      var event = $.Event(name);
      $parent.triggerHandler(event, data);
    }

    function replaceAll(string, context) {
      var html = string;
      context.forEach(el => {
        var regex = RegExp(el[0], 'g');
        html = html.replace(regex, el[1]);
      });
      return html;
    }

    if (conf.init) {
      methods.init();
    }

    $parent.data({
      Calendar: methods
    });

    return methods;
  }

  window.Calendar = Calendar;
})(jQuery, window);